import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { Images } from '../../../../../assets'

import { DropdownLocSide } from '../../../../dashboard/dashboard-dropdown.container'

import Styled from '../../final-transshipment.styled'
import Helper from '../../final-transshipment.helper'

const ReportFilter = ({ data, methods }) => {
  const { Location } = useSelector((state) => state.usersProfileReducer)
  const { UserLocations } = useSelector((state) => state.usersLoginReducer)

  return (
    <Styled.FilterWrapper>
      <Styled.FilterWrapper>
        <Styled.Label>Location</Styled.Label>
        <DropdownLocSide
          position='relative'
          location={Location}
          dataList={UserLocations}
          setLocation={methods.handleLocationChange}
        />
      </Styled.FilterWrapper>
      <Styled.FilterWrapper>
        <Styled.Label>Month</Styled.Label>
        <Styled.StyledDropDown
          textField='label'
          dataItemKey='value'
          data={Helper.ListMonths}
          value={data.filter.month}
          onChange={methods.handleMonthChange}
        />
      </Styled.FilterWrapper>
      <Styled.FilterWrapper>
        <Styled.Label>Year</Styled.Label>
        <Styled.StyledDropDown
          textField='label'
          dataItemKey='value'
          data={Helper.ListYears}
          value={data.filter.year}
          onChange={methods.handleYearChange}
        />
      </Styled.FilterWrapper>
      <Styled.FilterWrapper>
        <Styled.ButtonExport
          disabled={data.isExporting}
          onClick={methods.handleExportReport}
        >
          <img src={Images.ExportExcelIcon} alt='export' />
          Export to Excel
        </Styled.ButtonExport>
      </Styled.FilterWrapper>
    </Styled.FilterWrapper>
  )
}

ReportFilter.propTypes = {
  data: PropTypes.shape({
    filter: PropTypes.shape({
      month: PropTypes.string.isRequired,
      year: PropTypes.string.isRequired,
    }).isRequired,
    isExporting: PropTypes.bool.isRequired,
  }),
  methods: PropTypes.shape({
    handleLocationChange: PropTypes.func.isRequired,
    handleMonthChange: PropTypes.func.isRequired,
    handleYearChange: PropTypes.func.isRequired,
    handleExportReport: PropTypes.func.isRequired,
  }),
}

export default ReportFilter